export const validationParams = {
  passwordLength: 8,
};

export const validations = {
  required: (x: unknown) => !!x,
  password: (password: string) => password.length >= validationParams.passwordLength,
  email: (email: string) => email.includes('@'),
};
